"use strict";
//@ts-check
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NDArray = void 0;
var dtypes_1 = require("./dtypes");
/**
 * Multi dimensional array.
 */
var NDArray = /** @class */ (function () {
    function NDArray(flat, shape) {
        this.shape = shape || [flat.length]; // invariant: immutable
        this._flat = flat;
        this._simpleIndexes = null;
    }
    Object.defineProperty(NDArray.prototype, "dtype", {
        /** @category Attributes @readonly */
        get: function () {
            //@ts-ignore
            return this._flat.constructor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NDArray.prototype, "size", {
        /** @category Attributes @readonly */
        get: function () {
            return this._simpleIndexes == null ? this._flat.length : this._simpleIndexes.size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NDArray.prototype, "flat", {
        /** @category Attributes @readonly */
        get: function () {
            var _this = this;
            if (this._simpleIndexes == null)
                return this._flat;
            var indices = this._simpleIndexes.indices;
            //@ts-ignore
            return (0, dtypes_1.new_buffer)(indices.length, this.dtype).map(function (_, i) { return _this._flat[indices[i]]; });
        },
        /** @internal */
        set: function (list) {
            if (list.length != this.size)
                throw new Error("Length mismatch. Can't write ".concat(list.length, " values into ").concat(this.size, " available positions."));
            var n = this.size;
            if (this._simpleIndexes == null) {
                for (var i = 0; i < n; i++)
                    this._flat[i] = list[i];
            }
            else {
                var indices = this._simpleIndexes.indices;
                for (var i = 0; i < n; i++)
                    this._flat[indices[i]] = list[i];
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NDArray.prototype, "T", {
        /**
         * @category Transformations
         * Transpose.
        */
        get: function () {
            return this.transpose();
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Iterator over the first axis.
     * For 1D arrays, yields numbers.
     * For multidimensional arrays, yields array views.
     */
    NDArray.prototype[Symbol.iterator] = function () {
        var i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < this.shape[0])) return [3 /*break*/, 4];
                    return [4 /*yield*/, this.index(i)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    };
    Object.defineProperty(NDArray.prototype, "length", {
        /** @category Attributes @readonly */
        get: function () {
            return this.shape[0] || 0;
        },
        enumerable: false,
        configurable: true
    });
    /** @category Casting */
    NDArray.prototype.item = function () {
        if (this.size != 1)
            throw new Error("Can't convert array of size ".concat(this.size, " to scalar"));
        return this.dtype == Uint8Array ? !!this._flat[0] : this._flat[0];
    };
    return NDArray;
}());
exports.NDArray = NDArray;
var _globals_1 = require("./_globals");
_globals_1.GLOBALS.NDArray = NDArray;
var array_1 = require("./array");
// import { AxisArg, ReduceKwArgs } from './NDArray/reduce';
var kwargs_1 = require("./array/kwargs");
NDArray.prototype.modules = array_1.modules;
// const a = new NDArray(new Int32Array(20), [], Number)
// ==============================
//    Basic methods
// ==============================
var basic = array_1.modules.basic;
NDArray.prototype.reshape = function (shape) {
    var more_shape = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        more_shape[_i - 1] = arguments[_i];
    }
    return basic.reshape.apply(basic, __spreadArray([this, shape], __read(more_shape), false));
};
NDArray.prototype.ravel = function () {
    return basic.ravel(this);
};
NDArray.prototype.copy = function () {
    return basic.copy(this);
};
// ==============================
//    Indexing
// ==============================
NDArray.prototype.index = function () {
    var where = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        where[_i] = arguments[_i];
    }
    return array_1.modules.indexes.index(this, where);
};
// ==============================
//    Printing
// ==============================
NDArray.prototype.toString = function () {
    return array_1.modules.print.humanReadable(this);
};
// ==============================
//    Reduce
// ==============================
NDArray.prototype.any = kwargs_1.Method_a_axis_keepdims.defaultDecorator(array_1.modules.reduce.reducers.any);
NDArray.prototype.all = kwargs_1.Method_a_axis_keepdims.defaultDecorator(array_1.modules.reduce.reducers.all);
NDArray.prototype.sum = kwargs_1.Method_a_axis_keepdims.defaultDecorator(array_1.modules.reduce.reducers.sum);
NDArray.prototype.product = kwargs_1.Method_a_axis_keepdims.defaultDecorator(array_1.modules.reduce.reducers.product);
NDArray.prototype.max = kwargs_1.Method_a_axis_keepdims.defaultDecorator(array_1.modules.reduce.reducers.max);
NDArray.prototype.min = kwargs_1.Method_a_axis_keepdims.defaultDecorator(array_1.modules.reduce.reducers.min);
NDArray.prototype.argmax = kwargs_1.Method_a_axis_keepdims.defaultDecorator(array_1.modules.reduce.reducers.argmax);
NDArray.prototype.argmin = kwargs_1.Method_a_axis_keepdims.defaultDecorator(array_1.modules.reduce.reducers.argmin);
NDArray.prototype.mean = kwargs_1.Method_a_axis_keepdims.defaultDecorator(array_1.modules.reduce.reducers.mean);
NDArray.prototype.var = kwargs_1.Method_a_axis_ddof_keepdims.defaultDecorator(array_1.modules.reduce.reducers.var);
NDArray.prototype.std = kwargs_1.Method_a_axis_ddof_keepdims.defaultDecorator(array_1.modules.reduce.reducers.std);
NDArray.prototype.norm = kwargs_1.Method_a_ord_axis_keepdims.defaultDecorator(array_1.modules.reduce.reducers.norm);
NDArray.prototype.add = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["+"]);
NDArray.prototype.subtract = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["-"]);
NDArray.prototype.multiply = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["*"]);
NDArray.prototype.divide = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["/"]);
NDArray.prototype.mod = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["%"]);
NDArray.prototype.divide_int = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["//"]);
NDArray.prototype.pow = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["**"]);
NDArray.prototype.maximum = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["max"]);
NDArray.prototype.minimum = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["min"]);
NDArray.prototype.bitwise_or = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["|"]);
NDArray.prototype.bitwise_and = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["&"]);
NDArray.prototype.bitwise_or = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["^"]);
NDArray.prototype.bitwise_shift_right = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["<<"]);
NDArray.prototype.bitwise_shift_right = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary[">>"]);
NDArray.prototype.logical_or = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["or"]);
NDArray.prototype.logical_and = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["and"]);
NDArray.prototype.logical_xor = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["xor"]);
NDArray.prototype.greater = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary[">"]);
NDArray.prototype.less = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["<"]);
NDArray.prototype.greater_equal = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary[">="]);
NDArray.prototype.less_equal = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["<="]);
NDArray.prototype.equal = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["=="]);
NDArray.prototype.not_equal = kwargs_1.Method_other_out.defaultDecorator(array_1.modules.operators.op_binary["!="]);
// Unary operations: only boolean_not. Positive is useless and negative is almost useless
NDArray.prototype.bitwise_not = kwargs_1.Method_out.defaultDecorator(array_1.modules.elementwise.funcs.bitwise_not);
NDArray.prototype.logical_not = kwargs_1.Method_out.defaultDecorator(array_1.modules.elementwise.funcs.logical_not);
NDArray.prototype.negative = kwargs_1.Method_out.defaultDecorator(array_1.modules.elementwise.funcs.negative);
NDArray.prototype.abs = kwargs_1.Method_out.defaultDecorator(array_1.modules.elementwise.funcs.abs);
NDArray.prototype.isclose = array_1.modules.operators.isclose;
NDArray.prototype.allclose = array_1.modules.operators.allclose;
NDArray.prototype.assign = kwargs_1.Method_values_where.defaultDecorator(array_1.modules.operators.op_assign["="]);
NDArray.prototype.add_assign = kwargs_1.Method_values_where.defaultDecorator(array_1.modules.operators.op_assign["+="]);
NDArray.prototype.subtract_assign = kwargs_1.Method_values_where.defaultDecorator(array_1.modules.operators.op_assign["-="]);
NDArray.prototype.multiply_assign = kwargs_1.Method_values_where.defaultDecorator(array_1.modules.operators.op_assign["*="]);
NDArray.prototype.divide_assign = kwargs_1.Method_values_where.defaultDecorator(array_1.modules.operators.op_assign["/="]);
NDArray.prototype.mod_assign = kwargs_1.Method_values_where.defaultDecorator(array_1.modules.operators.op_assign["%="]);
NDArray.prototype.divide_int_assign = kwargs_1.Method_values_where.defaultDecorator(array_1.modules.operators.op_assign["//="]);
NDArray.prototype.pow_assign = kwargs_1.Method_values_where.defaultDecorator(array_1.modules.operators.op_assign["**="]);
NDArray.prototype.maximum_assign = kwargs_1.Method_values_where.defaultDecorator(array_1.modules.operators.op_assign["max="]);
NDArray.prototype.minimum_assign = kwargs_1.Method_values_where.defaultDecorator(array_1.modules.operators.op_assign["min="]);
NDArray.prototype.bitwise_or_assign = kwargs_1.Method_values_where.defaultDecorator(array_1.modules.operators.op_assign["|="]);
NDArray.prototype.bitwise_and_assign = kwargs_1.Method_values_where.defaultDecorator(array_1.modules.operators.op_assign["&="]);
NDArray.prototype.bitwise_shift_left_assign = kwargs_1.Method_values_where.defaultDecorator(array_1.modules.operators.op_assign["<<="]);
NDArray.prototype.bitwise_shift_right_assign = kwargs_1.Method_values_where.defaultDecorator(array_1.modules.operators.op_assign[">>="]);
NDArray.prototype.logical_or_assign = kwargs_1.Method_values_where.defaultDecorator(array_1.modules.operators.op_assign["or="]);
NDArray.prototype.logical_and_assign = kwargs_1.Method_values_where.defaultDecorator(array_1.modules.operators.op_assign["and="]);
// ==============================
//    array instantiation and reshaping
// ==============================
NDArray.prototype.tolist = function () {
    return array_1.modules.jsInterface.tolist(this);
};
// NDArray.prototype.fromJS = function (A) {
//   return modules.jsInterface.fromJS(A);
// }
// ==============================
//    elementwise methods
// ==============================
NDArray.prototype.round = kwargs_1.Method_a_decimals_out.defaultDecorator(array_1.modules.elementwise.funcs.round);
// ==============================
//    transform methods
// ==============================
/** @param {null|number[]} axes */
NDArray.prototype.transpose = function (axes) {
    if (axes === void 0) { axes = null; }
    return array_1.modules.transform.transpose(this, axes);
};
NDArray.prototype.sort = function (axis) {
    if (axis === void 0) { axis = -1; }
    array_1.modules.transform.sort(this, axis);
    return null;
};
var op = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (!args.length)
        return this;
    if (typeof args[0] == "string") {
        var symbol_1 = args[0];
        if (args.length == 1) {
            var func_1 = array_1.modules.elementwise.ops[symbol_1];
            if (!func_1)
                throw new Error("Unknown unary operator \"".concat(symbol_1, "\". Options:").concat(__spreadArray([], __read(Object.keys(array_1.modules.elementwise.ops)), false)));
            return func_1(this, symbol_1);
        }
        if (args.length > 2)
            throw new Error("Too many arguments provided: ".concat(__spreadArray([], __read(args), false)));
        var other_1 = args[1];
        var func_2 = array_1.modules.operators.op_binary[symbol_1];
        if (func_2)
            return func_2(this, other_1);
        func_2 = array_1.modules.operators.op_assign[symbol_1];
        if (func_2)
            return func_2(this, other_1);
        if (symbol_1.includes(':'))
            throw new Error("Expected index or operator symbol. Found \"".concat(symbol_1, "\". Did you mean ").concat([symbol_1], "?"));
        throw new Error("Expected index or operator symbol. Found \"".concat(symbol_1, "\""));
    }
    var where = args[0];
    if (where instanceof NDArray)
        throw new Error("Expected operator or index. Found numpy array");
    if (args.length == 1)
        return this.index(where);
    var symbol = args[1];
    var func = array_1.modules.operators.op_assign[symbol];
    if (!func)
        throw new Error("Unknown assign operator \"".concat(symbol, "\". Options:").concat(__spreadArray([], __read(Object.keys(array_1.modules.operators.op_assign)), false)));
    if (args.length > 3)
        throw new Error("Too many arguments provided: ".concat(__spreadArray([], __read(args), false)));
    var other = args[2];
    return func(this, where, other);
};
NDArray.prototype.op = op;
exports.default = NDArray;
